import React, { useMemo } from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

import { ValuesMap } from '@/common/types';

import UnableToDisplayPreview from './UnableToDisplayPreview';

interface Props {
  smsText: string;
  testId: string;
  isSMSTextLoading?: boolean;
  smsVariables?: ValuesMap<string | number | boolean>;
  isSmsTextError?: boolean;
  onRefetchSmsText?: () => void;
}

//  This element is not part of the  White Labeling and hardcoded for every client
const BACKGROUND_COLOR = '#0A84FF';
const TEXT_COLOR = '#FFF';

const ResendListItemSMSPreview :React.FC<Props> = ({
  smsText,
  testId,
  isSMSTextLoading,
  smsVariables,
  isSmsTextError,
  onRefetchSmsText,
}) => {
  const smsTextWithVariables = useMemo(() => {
    if (!smsText || !smsVariables) {
      return smsText;
    }

    let text = smsText;
    Object.keys(smsVariables).forEach((key) => {
      const value = smsVariables[key];
      if (value) {
        text = text.replace(`{{${key}}}`, value as string || '');
      }
    });
    return text;
  }, [smsText, smsVariables]);

  const content = useMemo(() => {
    if (isSMSTextLoading) {
      return (
        <ShimmerBox data-testid="sms-preview_loader" margin={{ top: 'spacing24' }} height='134px' />
      );
    }

    if (isSmsTextError) {
      return (
        <UnableToDisplayPreview onRefetch={onRefetchSmsText} />
      );
    }

    return (
      <Box
        align="center"
        background="border1"
        fill
        margin={{ top: 'l' }}
        pad={{vertical: 'xl'}}
        style={{ position: 'relative' }}
      >

        <Box
          width={{max: '280px'}}
          round="15px"
          background={BACKGROUND_COLOR}
          pad={{top: '9px', horizontal: 'm', bottom: 'm'}}
          style={{position: 'relative'}}
        >
          <Text size="17px" weight={400} data-testid={`${testId}_text`} color={TEXT_COLOR}>{smsTextWithVariables}</Text>

          <Box style={{position: 'absolute', right: '-3px', bottom: '-3px'}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M15.0285 0H0C0 7.73199 6.26801 14 14 14H20V13.6709C18.5689 12.4697 17.3842 10.9871 16.5262 9.30324C15.4038 7.10032 15.107 4.39657 15.0285 0Z" fill={BACKGROUND_COLOR}/>
            </svg>
          </Box>
        </Box>
      </Box>
    );
  }, [isSMSTextLoading, isSmsTextError, onRefetchSmsText, smsTextWithVariables, testId]);

  return (
    <Box direction='column' data-testid={testId}>
      <Box direction="row" align="center" justify="between">
        <Text size="xxlarge" weight={400}>
          Sent message
        </Text>
     
      </Box>

      {content}
    </Box>
  );
};

export default ResendListItemSMSPreview;